import * as React from 'react';
import { TransitionGroup } from 'react-transition-group';
import './notification.css';

const Notifications = ({ children }) => (
  <TransitionGroup className="chat-notifications" role="alert">
    {children}
  </TransitionGroup>
);

export default Notifications;
